import { useQuery } from '@tanstack/react-query'

type UserInfo = {
  sub?: string
  name?: string
  givenName?: string
  familyName?: string
  email?: string
  emailVerified?: boolean
  picture?: string
  preferredUsername?: string
}

const CSRF_COOKIE = '__Secure-bff_csrf'

const getCsrfToken = (): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${CSRF_COOKIE}=([^;]*)`))
  return match?.[1]
}

const fetchUserInfo = async (): Promise<UserInfo> => {
  const headers: Record<string, string> = {}
  const csrf = getCsrfToken()
  if (csrf) {
    headers['X-Csrf-Token'] = csrf
  }

  const response = await fetch('/api/identity/users/me/info', {
    credentials: 'include',
    headers,
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch user info: ${response.status}`)
  }

  return response.json()
}

export const useUserInfo = () => {
  return useQuery({
    queryKey: ['userinfo'],
    queryFn: fetchUserInfo,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
